import { render, staticRenderFns } from "./ProductCategoryShowData.vue?vue&type=template&id=00f19e21"
import script from "./ProductCategoryShowData.vue?vue&type=script&lang=js"
export * from "./ProductCategoryShowData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports